/* istanbul ignore file */

import React from "react";
import { Provider } from "react-redux";
import { createRoot } from "react-dom/client";

import App from "./app/App";
import * as serviceWorker from "./services/serviceWorker";
import configureStore from "./state/store";

import "./index.scss";
import "./theme/fonts/custom-fonts.scss";

import { BrowserRouter } from "react-router-dom";

import utc from "dayjs/plugin/utc";
import dayjs from "dayjs";

dayjs.extend(utc);

const store = configureStore({});

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
